import styled from 'styled-components';
import { Button } from "@material-ui/core";
import { EventOutlined as EventOutlinedIcon, WorkOutline as WorkOutlineIcon, AddCircleOutline as AddCircleOutlineIcon } from "@material-ui/icons";

import tokenWhite from 'images/tokenWhite.svg'

// T2-6042: This component is mounted inside JobBoardPage's ContentWrapper
// (max-width 900px with its own 16px padding). The Back button at the top
// sits at that edge, so for alignment we don't add ANY additional horizontal
// padding here — header / tabs / Post-a-New-Job button / job cards all line
// up flush with the Back button above.
export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 1rem 0 120px;
  background-color: #fff;
  height: auto;
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  overflow: visible;
  box-sizing: border-box;

  @media(min-width: 768px) {
    padding: 2rem 0 140px;
  }

  @media (max-height: 700px) {
    padding-bottom: 100px;
  }
`

// T2-6042: Header row — left-aligned with the Back button above (no
// horizontal padding) so the title and Total Tokens card line up with the
// page edge that the Back button uses.
export const HeaderRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin: 0.5rem 0 1.25rem;
  padding: 0;
  width: 100%;
  box-sizing: border-box;
`

export const HeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
`

export const Title = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.87);
  line-height: 1.2;

  @media(min-width: 768px) {
    font-size: 1.875rem;
  }
`

export const Subtitle = styled.div`
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.6);
  line-height: 1.4;
`

export const TotalPostsCard = styled.div`
  display: flex;
  align-items: center;
  gap: 0.625rem;
  padding: 0.625rem 0.875rem;
  background: #fff;
  border: 1px solid #E0E5EE;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(11, 69, 152, 0.06);
  flex-shrink: 0;
  cursor: pointer;
  transition: box-shadow 0.15s ease, border-color 0.15s ease, transform 0.05s ease;

  &:hover {
    border-color: var(--primary-blue, #0B4598);
    box-shadow: 0 2px 8px rgba(11, 69, 152, 0.18);
  }

  &:active {
    transform: scale(0.98);
  }

  &:focus-visible {
    outline: 2px solid var(--primary-blue, #0B4598);
    outline-offset: 2px;
  }
`

// T2-6042: Per Holly — keep the existing circle "token" icon (white token
// glyph on cobalt background) instead of the ChatGPT-mockup briefcase.
export const TotalPostsIconWrap = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: var(--primary-blue, #0B4598);
  color: #fff;

  /* override the legacy margin-right on TokenIcon when it lives in this wrap */
  & > img {
    width: 22px;
    height: 16px;
    margin: 0 !important;
  }
`

export const TotalPostsTextWrap = styled.div`
  display: flex;
  flex-direction: column;
  line-height: 1.1;
`

export const TotalPostsLabel = styled.div`
  font-size: 0.7rem;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 500;
  white-space: nowrap;
`

export const TotalPostsCount = styled.div`
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--primary-blue, #0B4598);
`

// Legacy tokens chip (kept for backwards compat with any other surfaces that
// still pass tokensCount into SectionTabs). The Job Posts header no longer
// uses this — it renders TotalPostsCard above instead.
export const TokensButton = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem;
  margin-left: 0.5rem;
  max-height: 1.5rem;
  background-color: #0B4598;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  border-radius: 0.5rem;
`

export const TokenIcon = styled.img.attrs({
    src: tokenWhite,
})`
  width: 16px;
  height: 12px;
  margin-right: 0.25rem;
`

// T2-6042: needs !important on margin to beat the global
// .bigButtonInNewStyle rule in src/index.css which forces margin:0.25rem 0.
// Width is left at 100% so the button matches the JobList cards below it.
export const StyledButton = styled(Button)`
  && {
    width: 100% !important;
    padding: 0.875rem 1.5rem !important;
    border-radius: 12px !important;
    display: flex !important;
    align-items: center;
    justify-content: center;
    margin: 0.5rem 0 1.5rem 0 !important;
    text-transform: none !important;
    font-weight: 600 !important;
    font-size: 0.95rem !important;
  }
`

export const EventOutlinedIconStyled = styled(EventOutlinedIcon)`
  margin-left: 0.25rem;
`

export const StyledAddCircleOutlineIcon = styled(AddCircleOutlineIcon)`
  margin-right: 0.5rem;
`

export const StyledWorkOutlineIcon = styled(WorkOutlineIcon)`
  /* used inside TotalPostsIconWrap */
`

export const NoJobsMessage = styled.div`
  width: 100%;
  text-align: center;
  margin: 3rem 0;
  padding: 0 1.5rem;
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.67);
`

// T2-6042: Plain wrapper around the JobList — kept as a styled element so
// the JSX stays consistent, but without any width constraint (lets the cards
// take the natural page-content width).
export const JobListWrap = styled.div`
  width: 100%;
`

